import { render } from "./user-creditor.vue?vue&type=template&id=38ab3164&scoped=true"
import script from "./user-creditor.vue?vue&type=script&lang=js"
export * from "./user-creditor.vue?vue&type=script&lang=js"

import "./user-creditor.vue?vue&type=style&index=0&id=38ab3164&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ab3164"]])

export default __exports__